/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Lap_NextInputs */

const en_ui_lap_next = /** @type {(inputs: Ui_Lap_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next lap`)
};

const de_ui_lap_next = /** @type {(inputs: Ui_Lap_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Runde`)
};

/**
* | output |
* | --- |
* | "Next lap" |
*
* @param {Ui_Lap_NextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_lap_next = /** @type {((inputs?: Ui_Lap_NextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Lap_NextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_lap_next(inputs)
	return de_ui_lap_next(inputs)
});